<template>
	<div
		v-click-outside.capture="closeMenu"
		class="relative inline-flex text-left"
		@keydown.esc.stop="closeOnEscape"
		@focusout="handleFocusOut"
	>
		<Button
			ref="trigger"
			type="tertiary"
			:size="size"
			icon-only
			:disabled="loading || (disabled && !disabledReason)"
			:aria-disabled="disabled ? 'true' : null"
			:aria-label="triggerLabel"
			v-tooltip="disabled ? disabledReason : null"
			:aria-expanded="isOpen ? 'true' : 'false'"
			aria-haspopup="menu"
			class="shrink-0 focus-visible:ring-2 focus-visible:ring-grey-950 aria-disabled:cursor-not-allowed aria-disabled:text-grey-500 aria-disabled:hover:bg-transparent"
			data-test="move-to-stage-trigger"
			@click.stop="toggleMenu"
		>
			<IconEllipsisHorizontal size="16" class="shrink-0" />
		</Button>

		<div
			v-if="isOpen && !disabled"
			ref="menu"
			class="fixed z-[70] flex w-max min-w-[253px] max-w-[calc(100vw-16px)] flex-col items-start gap-3 rounded-lg bg-white p-4 shadow-lg ring-1 ring-inset ring-grey-200"
			role="menu"
			:aria-label="heading || $t('application.move-stage.change-stage')"
			@keydown.down.prevent="focusNextOption(1)"
			@keydown.up.prevent="focusNextOption(-1)"
			@keydown.tab="closeMenu()"
		>
			<p
				v-if="heading"
				class="mb-0 w-full truncate text-sm font-medium text-grey-1000"
			>
				{{ heading }}
			</p>

			<MoveToStageOptions :status="status" @select="select" />
		</div>
	</div>
</template>

<script>
import Button from '~/components/ui/common/Button'
import { IconEllipsisHorizontal } from '~/components/Icons'
import popoverMenu from '~/mixins/popoverMenu'
import MoveToStageOptions from './MoveToStageOptions.vue'

export default {
	name: 'MoveToStageMenu',
	components: { Button, IconEllipsisHorizontal, MoveToStageOptions },
	mixins: [popoverMenu],
	props: {
		status: { type: String, required: true },
		heading: { type: String, default: '' },
		disabled: { type: Boolean, default: false },
		// Keeps a blocked trigger focusable so keyboard users can read why.
		disabledReason: { type: String, default: null },
		loading: { type: Boolean, default: false },
		size: { type: String, default: null }
	},
	computed: {
		triggerLabel() {
			const label = this.$t('application.move-stage.change-stage')

			return this.disabled && this.disabledReason
				? `${label}: ${this.disabledReason}`
				: label
		}
	},
	methods: {
		select(status) {
			if (this.loading || this.disabled) return

			this.closeMenu()
			this.focusTrigger()
			this.$emit('select', status)
		}
	}
}
</script>
